import { Outlet, useLocation } from "react-router-dom";
import { observer } from "mobx-react";
import { useStores } from "@src/hooks/useStores";

import Navbar from "@layout/Navbar";
import Footer from "@layout/Footer";
import { Flex } from "@chakra-ui/react";
import React, { useEffect } from "react";
import Sidebar from "../Sidebar";
import colors from "@src/style/colors";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const RootLayout: React.FC = observer(() => {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Sidebar />
      <Flex
        flexDirection={"column"}
        justifyContent="center"
        alignContent="center"
        backgroundColor={colors.white}>
        <Outlet />
        <Footer />
      </Flex>
    </>
  );
});

export default RootLayout;

// const [isSmall, isMedium, isLarge] = useMediaQuery([
//   `(min-width: ${breakpoints.sm})`,
//   `(min-width: ${breakpoints.md})`,
//   `(max-width: ${breakpoints.lg})`
// ]);
